export const skillsList = [
  { id: 1, label: "C" },
  { id: 2, label: "C#" },
  { id: 3, label: "C++" },
  { id: 4, label: "Java" },
  { id: 5, label: "Python" },
  { id: 6, label: "JavaScript" },
  { id: 7, label: "HTML / CSS" },
  { id: 8, label: "SQL" },
  { id: 9, label: "Unity" },
  { id: 10, label: "Godot" },
  { id: 11, label: "React" },
  { id: 12, label: "Machine Learning" },
  { id: 13, label: "Data Science" },
  { id: 14, label: "3D Modelling" },
  { id: 15, label: "Git / GitHub" },
  { id: 16, label: "Blender" },
  { id: 17, label: "Video Editing" },
  { id: 18, label: "Asset Creation" },
  { id: 19, label: "Web Development" },
  { id: 20, label: "Game Development" },
];
